import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cac9c9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-collection-bin" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "collection-title" }
const _hoisted_4 = { class: "title" }

import { provide, computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { ColletionBinStore } from '@/stores';
  import { PDOType } from '@/types/pdo';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const collectionBinStore = ColletionBinStore.create<ColletionBinStore>({ id: route.params.binId });
  collectionBinStore.fetchData();
  provide('collectionBinStore', collectionBinStore);

  const title = computed(() => {
    if (collectionBinStore.isOfflineCollection) {
      return collectionBinStore.data.company_account.name;
    }
    if (collectionBinStore.isPDO) {
      return (collectionBinStore.data.target as PDOType)?.facility_name;
    }
    return '';
  });


return (_ctx: any,_cache: any) => {
  const _component_AppCustomLink = _resolveComponent("AppCustomLink")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(collectionBinStore).isFulfilled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(title)), 1),
            _createVNode(_component_AppCustomLink, {
              to: { name: 'programs.show', params: { slug: _unref(collectionBinStore).data.program?.slug } },
              "custom-domain": _unref(collectionBinStore).data.program?.custom_campaign_domain,
              class: "subtitle"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(collectionBinStore).data.program?.name), 1)
              ]),
              _: 1
            }, 8, ["to", "custom-domain"])
          ]),
          _createVNode(_component_router_view, { class: "main-view" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})